import { Configuration, RedirectRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        // Pin the redirect URI to the registered root reply URL (browsers load the root as
        // origin + "/"). Without this, MSAL would use the current deep-link path (e.g.
        // /subscriptions/5) as the redirect URI on a logged-out refresh, which isn't a
        // registered reply URL -> AADSTS50011. With navigateToLoginRequestUrl left default
        // (true), MSAL returns to the root, processes the hash, then navigates back to the
        // originally-requested deep link, so deep links survive login.
        redirectUri: window.location.origin + "/"
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
        secureCookies: false
    },
};

export const signInScopes: string[] = [
    "User.Read"
];

export const sitesScopes: string[] = [
    "Sites.Read.All"
];

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const authRequest: RedirectRequest = {
    scopes: signInScopes
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};